import defaultAttributes from '../defaultAttributes';

const Baseline = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4 20h16' }],
    ['path', { d: 'M6 16l6-12 6 12' }],
    ['path', { d: 'M8 12h8' }],
  ],
];

export default Baseline;
